<script lang="ts" setup>
  import { definePage } from 'unplugin-vue-router/runtime'
  import { usePaymentDialog } from '@/composables/usePaymentDialog.ts'
  import { useAuthStore } from '@stores/auth.ts'

  definePage({
    meta: {
      authenticated: true,
      title: 'subscriptions_index',
    },
  })
  const router = useRouter()
  const route = useRoute()
  const authStore = useAuthStore()
  const paymentDialog = usePaymentDialog()
  const onClose = async () => {
    await router.push({ path: '/' })
  }
  if(route.query?.coupon) {
    window.settings.public_coupon = route.query?.coupon as string
  }


  onMounted(async () => {
    if(authStore.isAuthenticated && authStore.isSubscribed){
      await router.push({ path: '/' })
    }else{
      paymentDialog.show()
      paymentDialog.onClose(onClose)

    }

  })
</script>

<template>
  <v-container />
</template>

<style scoped>
</style>
